import React from "react";
import T from "prop-types";

import Buttons from "2g-buttons";
import { Icons } from "2g-icons";

function Priloha({ file, onDelete, onDownload, disabled }) {
  return (
    <div className="b2b-Priloha">
      <Icons.Document className="b2b-Priloha-icon" />
      <span className="b2b-Priloha-name">{file.name}</span>
      <span className="b2b-Priloha-actions">
        {!disabled && file.key && onDownload ? (
          <Buttons.Primary
            key="download"
            onClick={() => onDownload(file)}
            inverse
            rounded
            type="button"
          >
            <Icons.Download />
          </Buttons.Primary>
        ) : null}
        {!disabled && onDelete ? (
          <Buttons.Danger
            key="delete"
            onClick={() => onDelete(file)}
            inverse
            rounded
            type="button"
          >
            <Icons.Close />
          </Buttons.Danger>
        ) : null}
      </span>
    </div>
  );
}

Priloha.propTypes = {
  file: T.object,
  onDownload: T.func,
  onDelete: T.func,
  disabled: T.bool
};

export default React.memo(Priloha);
